import { apiClient } from "../../../lib";

export const portfolioApi = {
  fetchPortfolios: async (params?: Record<string, any>): Promise<any> => {
    const searchParams = new URLSearchParams();
    
     if (params?.my_tasks) {
      searchParams.append("assign_to_me", "true");
    }
    
    Object.entries(params || {}).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          if (v) searchParams.append(key, String(v));
        });
      } else if (value) {
        searchParams.append(key, String(value));
      }
    });
    const queryString = searchParams.toString();
    const response = await apiClient.get(`/portfolios?${queryString}`);
    return response.data;
  },
  createPortfolio: async ({ payload }: { payload: any }): Promise<any> => {
    const response = await apiClient.post("/portfolios", payload);
    return response.data;
  },
  editPortfolio: async ({ portfolioId, payload }: { portfolioId: string, payload: any }) => {
    const response = await apiClient.put(`/portfolios/${portfolioId}`, payload);
    return response.data;
  },
  getPortfolioDetails: async ({ portfolioId }: { portfolioId: string | undefined }): Promise<any> => {
    if (!portfolioId) {
      throw new Error("Portfolio ID is required");
    }
    const response = await apiClient.get(`/portfolios/${portfolioId}`);
    return response.data;
  },
  fetchPortfoliosList: async() => {
    const response = await apiClient.get(`/portfolios/autocomplete`);
    return response.data;
  }
};
